<template>
  <div v-rect-loading="loading" class="question-list">
    <TableList
      :listData="listData"
      :tableColumns="tableColumns"
      :actionBtn="actionBtn"
      @create="handleCreate"
    >
      <template #status="{ row, data }">
        <el-switch :value="data" @change="onEnabledChange($event, row)"></el-switch>
      </template>
    </TableList>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { JOB_APPLICATION_QUESTION_TYPE } from '@/constant/questionnaire'
import TableList from '@/components/tableList/allowDragSortTable.vue'

export default {
  components: {
    TableList
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.jobApplication',
      questionType: JOB_APPLICATION_QUESTION_TYPE,
      listData: []
    }
  },
  computed: {
    previewLocale () {
      return this.$parent.activePreviewLocale
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.questionName`),
          dataKey: 'content',
          formatter: (data, row) => {
            return row[`content_${this.previewLocale}`]
          }
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.questionType`),
          dataKey: 'type',
          formatter: (data) => {
            const i18nKey = this.questionType[data].i18nKey
            return this.$t(i18nKey)
          }
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.questionStatus`),
          dataKey: 'status',
          slotName: 'status'
        }
      ]
      return columns
    },
    actionBtn () {
      return {
        edit: {
          show: true,
          onclick: this.handleEdit
        }
      }
    }
  },
  created () {
    this.fetchListData()
  },
  methods: {
    ...mapActions('jobApplicationManagement', [
      'searchQuestion',
      'updateQuestion'
    ]),
    async fetchListData () {
      this.loading = true
      try {
        const resp = await this.searchQuestion()
        if (resp && resp.question) {
          this.listData = _.chain(resp.question)
            .map(item => {
              return {
                ...item,
                status: item.status === 1
              }
            })
            .orderBy(['status'], ['desc'])
            .value()
        }
      } finally {
        this.loading = false
      }
    },
    handleCreate () {
      this.$router.push('/v-admin/job-application-management/question/add')
    },
    handleEdit (rowData) {
      this.$router.push(`/v-admin/job-application-management/question/edit/${rowData.id}`)
    },
    async onEnabledChange (status, rowData) {
      this.loading = true
      try {
        const statusData = {
          id: rowData.id,
          change_status: status
        }
        const resp = await this.updateQuestion(statusData)
        if (resp) {
          rowData.status = statusData.change_status
          this.$message.success(this.$t('common.message.optionSuccess'))
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
